import { SPAM_WORD_CATEGORY } from '../../SpamWords/utils';
import * as cheerio from 'cheerio';

export type SpamCheckResult = {
  score: number,
  spamWords: { category: string, word: string, count: number }[],
};

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

// eslint-disable-next-line import/prefer-default-export
export const getSpamCheckResult = (
  html: string,
  spamWords: { word: string, category: string }[],
): SpamCheckResult => {
  const $ = cheerio.load(html),
    text = $('body')
      .text()
      .replace(/%[a-zA-Z0-9]+%/g, '');
  const convertToSingleSpace = text.trim().replace(/\s+/g, ' ');
  const spamWordsFound = [];
  let score = 0;
  spamWords.forEach(spamWord => {
    const regexp = new RegExp(
      `\\b${escapeRegExp(spamWord.word.trim())}\\b`,
      'gi',
    );
    const matches = convertToSingleSpace.match(regexp);
    if (matches) {
      const scoreByCategory =
        SPAM_WORD_CATEGORY.find(
          category => category.value === spamWord.category,
        )?.score || 0;
      score += scoreByCategory * matches.length;
      spamWordsFound.push({
        ...spamWord,
        count: matches.length,
      });
    }
  });

  return {
    score,
    spamWords: spamWordsFound,
  };
};
